// components/SearchModal.tsx
import React, { useState, useEffect } from "react";
import {
  Modal,
  Box,
  TextField,
  InputAdornment,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";

const style = {
  position: "fixed" as const,
  top: "20%",
  left: "50%",
  transform: "translate(-50%, -20%)",
  width: "90%",
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: 2,
};

interface Props {
  open: boolean;
  onClose: () => void;
}

const SearchModal: React.FC<Props> = ({ open, onClose }) => {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (value.trim()) {
      navigate(`/search?q=${encodeURIComponent(value.trim())}`);
      onClose(); // Close the modal
    }
  };

  useEffect(() => {
    if (open) {
      setValue("");
    }
  }, [open]);

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={style}>
        <form onSubmit={handleSubmit}>
          <TextField
            autoFocus
            fullWidth
            placeholder="Search artists, albums, tracks..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={onClose}>
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </form>
      </Box>
    </Modal>
  );
};

export default SearchModal;
